export const RESULTS_PATHNAME = '/results';
export const SEARCH_QUERY_KEY = 'search';